
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLanguage } from '@/context/LanguageContext';

const CookiePolicy = () => {
  const { t } = useLanguage();

  return (
    <>
      <Helmet>
        <title>Cookie Policy | Global Therapy Hub</title>
        <meta name="description" content="Learn about how we use cookies and similar technologies to improve your experience on our platform." />
      </Helmet>

      <div className="min-h-screen bg-white">
        <div className="container mx-auto px-4 py-16 max-w-4xl">
          <h1 className="text-4xl font-bold text-gray-900 mb-8">Cookie Policy</h1>
          
          <div className="prose prose-lg max-w-none">
            <p className="text-gray-600 mb-8">
              Last updated: January 2024
            </p>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">What Are Cookies</h2>
              <p className="text-gray-700">
                Cookies are small text files that are placed on your device when you visit our website. 
                They help us provide you with a better experience by remembering your preferences and 
                helping us understand how you use our platform.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Types of Cookies We Use</h2>
              
              <h3 className="text-xl font-semibold text-gray-900 mb-3">Essential Cookies</h3>
              <p className="text-gray-700 mb-4">
                These cookies are necessary for the website to function properly. They enable basic 
                functions like page navigation and access to secure areas of the website.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">Performance Cookies</h3>
              <p className="text-gray-700 mb-4">
                These cookies help us understand how visitors interact with our website by collecting 
                and reporting information anonymously.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">Functionality Cookies</h3>
              <p className="text-gray-700 mb-4">
                These cookies allow the website to remember choices you make and provide enhanced, 
                more personal features.
              </p>

              <h3 className="text-xl font-semibold text-gray-900 mb-3">Targeting Cookies</h3>
              <p className="text-gray-700">
                These cookies may be set through our site by our advertising partners to build a 
                profile of your interests and show you relevant adverts on other sites.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">How We Use Cookies</h2>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>To keep you logged in to your account</li>
                <li>To remember your language and region preferences</li>
                <li>To analyze website traffic and performance</li>
                <li>To personalize your experience on our platform</li>
                <li>To provide secure payment processing</li>
                <li>To prevent fraud and enhance security</li>
              </ul>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Managing Cookies</h2>
              <p className="text-gray-700 mb-4">
                You can control and manage cookies in various ways:
              </p>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>Most web browsers allow you to control cookies through their settings</li>
                <li>You can delete existing cookies from your browser</li>
                <li>You can set your browser to prevent cookies from being placed</li>
                <li>You can set your browser to notify you when cookies are being used</li>
              </ul>
              <p className="text-gray-700 mt-4">
                Please note that disabling cookies may affect the functionality of our website 
                and your user experience.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Third-Party Cookies</h2>
              <p className="text-gray-700">
                We may use third-party services that place cookies on your device. These include 
                analytics services, payment processors, and other service providers that help us 
                operate our platform effectively.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-900 mb-4">Contact Us</h2>
              <p className="text-gray-700">
                If you have questions about our use of cookies, please contact us at:
              </p>
              <p className="text-gray-700 mt-4">
                Email: privacy@psychotherapist.help<br />
                Address: Global Therapy Hub Privacy Team
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default CookiePolicy;
